import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class PartnersApi extends CollectionApi {
  constructor() {
    super('/api/v2/partners', {
      skip: 0,
      limit: 50,
      sort: 'name',
    });
  }

  /**
   * Allow the partner to be linked to the JumpCloud organization
   * @param {ObjectId} id Partner Id
   */
  allowLink(id) {
    return this
      .initialize()
      .then(() => axios.post(`${this.baseUrl}/${id}/allow`, {}));
  }

  /**
   * Deny the partner from being linked to the JumpCloud organization
   * @param {ObjectId} id Partner Id
   */
  denyLink(id) {
    return this
      .initialize()
      .then(() => axios.post(`${this.baseUrl}/${id}/deny`, {}));
  }

  /**
   * Disconnect the linked partner from the JumpCloud organization
   * @param {ObjectId} id Partner Id
   */
  disconnect(id) {
    return this
      .initialize()
      .then(() => axios.post(`${this.baseUrl}/${id}/disconnect`, {}));
  }
}

export default new PartnersApi();
